import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface WorkflowTriggerData {
  isSystemGenerated: boolean;
  taskId?: string;
  requestId?: string;
}

interface WorkflowTriggerState {
  loading: boolean;
  success: boolean;
  message: string | null;
  error: string | null;
  data: WorkflowTriggerData | null;
}

const initialState: WorkflowTriggerState = {
  loading: false,
  success: false,
  message: null,
  error: null,
  data: null,
};

const workflowTriggerSlice = createSlice({
  name: 'workflowTrigger',
  initialState,
  reducers: {
    // Fetch workflow status (GET request)
    fetchWorkflowStatusRequest: (state, action: PayloadAction<{ restaurantId: string }>) => {
      state.loading = true;
      state.error = null;
    },
    fetchWorkflowStatusSuccess: (state, action: PayloadAction<{ success: boolean; message: string; data: WorkflowTriggerData }>) => {
      state.loading = false;
      state.success = action.payload.success;
      state.message = action.payload.message;
      state.data = action.payload.data;
      state.error = null;
    },
    fetchWorkflowStatusFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    // Trigger workflow (POST request)
    triggerWorkflowRequest: (state, action: PayloadAction<{ restaurantId: string }>) => {
      state.loading = true;
      state.error = null;
      state.success = false;
      state.message = null;
      state.data = null;
    },
    triggerWorkflowSuccess: (state, action: PayloadAction<{ success: boolean; message: string; data: WorkflowTriggerData }>) => {
      state.loading = false;
      state.success = action.payload.success;
      state.message = action.payload.message;
      state.data = action.payload.data;
      state.error = null;
    },
    triggerWorkflowFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
      state.message = null;
      state.data = null;
    },
    resetWorkflowTrigger: (state) => {
      state.loading = false;
      state.success = false;
      state.message = null;
      state.error = null;
      state.data = null;
    },
  },
});

export const {
  fetchWorkflowStatusRequest,
  fetchWorkflowStatusSuccess,
  fetchWorkflowStatusFailure,
  triggerWorkflowRequest,
  triggerWorkflowSuccess,
  triggerWorkflowFailure,
  resetWorkflowTrigger,
} = workflowTriggerSlice.actions;

export default workflowTriggerSlice.reducer;
